module.exports = __webpack_public_path__ + "static/media/icon.ffc83e09.png";